import styles from "../styles/Site.module.css";

const SCHOLAR = "https://scholar.google.com/citations?user=TENblEUAAAAJ&hl=en";

const ProfileIntro = () => {
    return (
        <>
            <p className={styles.lede}>
                I'm currently a researcher at OpenAI in San Francisco.
            </p>
            <p>
                Previously I was at Tilde Research, where I mainly worked on optimizers for deep learning. Before that I was at the Vector Institute while doing my undergrad, where I worked on Bayesian learning and optimization with Daniel Roy and Wu Lin. I also studied complexity and pseudorandomness with Roei Tell; I was particularly interested in circuit lower bounds and the P ?= BPP problem. Before university I interned at Wolfe Lab, Harvard Medical School, where I studied visual attention.
            </p>
            <p>I grew up in Sudbury, Ontario, and I like collecting watches. One of my favorite quotes is:</p>
            <blockquote className={styles.quote}>
                <p>
                    “That's not how he wanted the story to go—and he wouldn't have any other story. So he tore up the world.”
                </p>
                <cite className={styles.quoteCite}>John Steinbeck, East of Eden</cite>
            </blockquote>
            <ul className={styles.meta}>
                <li><a href="mailto:alecdewulf@gmail.com">Email</a></li>
                <li><a href={SCHOLAR}>Scholar</a></li>
                <li><a href="https://github.com/aldew5">GitHub</a></li>
            </ul>
        </>
    );
};

export default ProfileIntro;
